import { render, staticRenderFns } from "./GetStart.vue?vue&type=template&id=d339bcd4&scoped=true&"
import script from "./GetStart.vue?vue&type=script&lang=js&"
export * from "./GetStart.vue?vue&type=script&lang=js&"
import style0 from "./GetStart.vue?vue&type=style&index=0&id=d339bcd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d339bcd4",
  null
  
)

export default component.exports